<script>
    import DOMPurify from "dompurify";
    import {onMount} from "svelte";

    let { id = '', class: className = '', ...rest } = $props();

    const messages = [];
    let currentIndex = 0;
    let message = $state('');

    export function addMessage(key, htmlMessage) {
        const index = messages.findIndex(msg => msg.key == key);

        if (index == -1) {
            messages.push({
                key: key,
                message: htmlMessage
            });
        }
    }

    export function removeMessage(key) {
        const index = messages.findIndex(msg => msg.key == key);

        if (index !== -1) {
            messages.splice(index, 1);
        }
    }

    export function clearMessages() {
        messages.length = 0;
    }

    function nextMessage() {
        if (messages.length == 0) {
            return '';
        }

        currentIndex = (currentIndex + 1) % messages.length;
        return messages[currentIndex].message;
    }

    onMount(() => {
        DOMPurify.addHook('uponSanitizeAttribute', function(node, attr) {
            if (node.tagName && node.tagName.toLowerCase() === 'a' && node.hasAttribute('target')) {
                node.setAttribute('rel', 'noopener noreferrer');
            }
        });

        const intervalId = setInterval(() => {
            message = nextMessage();
        }, 3000);

        return () => {
            clearInterval(intervalId);
        };
    });
</script>

<div {id} {...rest} class={`top-bar ellipsis ${className}`.trim()} role="status">
    {#if message}
        {@html DOMPurify.sanitize(message, {ADD_ATTR: ['target']})}
    {/if}
</div>


<style>
    .top-bar {
        padding-left: var(--brak-site-padding);
        padding-right: var(--brak-site-padding);
        height: var(--brak-top-bar-height);
        line-height: var(--brak-top-bar-height);
        text-align: center;
    }

    .top-bar:empty {
        display: none;
    }

    .top-bar :global(.full-bar-link) {
        color: inherit;
        text-decoration: none;
        cursor: pointer;
        display: inline-block;
        width: 100%;
        height: 100%;
    }
</style>
